/* B360 · the sticky purchase shortcut on product pages.
   An EXTRA control. The theme's own add-to-bag / pre-order button stays where it is; this small capsule (button left, price right) is shown only while that
   button is out of sight above the screen, and it goes away before the button comes back into reach. It does not run a cart flow of its own: pressing it
   presses the main button (same action, same variant, same sold-out rules), and it copies the main button's words, state and the price of the selected variant
   (so a variant change updates it at once). Visibility comes from an IntersectionObserver on the main button, not from scroll offsets. */
(function () {
  'use strict';
  var cap = document.querySelector('[data-b360-sbuy]');
  if (!cap) return;
  var form = document.querySelector('product-form.m-product-form--main') || document.querySelector('product-form');
  var main = form && form.querySelector('.m-add-to-cart');
  if (!main) return;
  document.body.appendChild(cap);                           // out of any transformed ancestor, so "fixed" is really the screen
  var btn = cap.querySelector('[data-b360-sbuy-btn]'), txt = cap.querySelector('[data-b360-sbuy-text]'), price = cap.querySelector('[data-b360-sbuy-price]');
  var norm = function (s) { return String(s || '').replace(/\s+/g, ' ').trim(); };

  function priceText() {
    var el = form.querySelector('.m-price'); if (!el) return '';
    var on = el.classList.contains('m-price--on-sale') ? el.querySelector('.m-price-item--sale') : el.querySelector('.m-price-item--regular');
    return norm((on || el.querySelector('.m-price-item') || {}).textContent);
  }
  function disabled() { return main.disabled || main.classList.contains('disabled') || main.getAttribute('aria-disabled') === 'true' || main.hasAttribute('disabled'); }
  function sync() {
    var t = norm((main.querySelector('.m-add-to-cart--text') || main).textContent);
    if (txt.textContent !== t) txt.textContent = t;
    var p = priceText(); if (price.textContent !== p) price.textContent = p; price.hidden = !p;
    var d = disabled(); cap.classList.toggle('is-disabled', d); btn.setAttribute('aria-disabled', d ? 'true' : 'false');
  }
  btn.addEventListener('click', function () { if (disabled()) return; main.click(); });   // the very same action as the main button
  new MutationObserver(sync).observe(form, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
  document.addEventListener('variant:change', sync); document.addEventListener('shopify:section:load', sync);
  window.setInterval(sync, 1500);                           // belt and braces: a theme that rewrites the price outside the form is still picked up
  sync();

  /* In Shopify's draft preview a bar is pinned to the bottom of the screen; the capsule sits above it (on the live site there is no bar and this is 0) */
  function bar() { var f = document.getElementById('PBarNextFrameWrapper'), h = 0; if (f) { var r = f.getBoundingClientRect(); if (r.height > 0 && r.bottom >= (window.innerHeight || 0) - 2) h = Math.ceil(r.height); } cap.style.setProperty('--b360-pbar', h + 'px'); }
  bar(); window.addEventListener('resize', bar); window.setTimeout(bar, 1500); window.setTimeout(bar, 4000);

  function show(on) {
    if (cap.classList.contains('is-on') === on) return;
    cap.classList.toggle('is-on', on); cap.setAttribute('aria-hidden', on ? 'false' : 'true'); btn.tabIndex = on ? 0 : -1;
  }
  if (!('IntersectionObserver' in window)) return;
  /* The margin makes "close enough" mean: within about a hand's width of the main button, above or below the screen, counts as in reach. */
  new IntersectionObserver(function (es) {
    var e = es[es.length - 1];
    show(!e.isIntersecting && e.boundingClientRect.top < 0 && e.boundingClientRect.height > 0);   // only once the button has gone UP out of reach
  }, { rootMargin: '140px 0px 140px 0px', threshold: 0 }).observe(main);
})();
